<template>

    <q-layout view="lHh Lpr lFf" container  v-fill-height="fillHeight" class="shadow-1 teal-1-bg">

      <q-header v-if="$slots.actions||$slots.header" reveal elevated>
        <q-toolbar  class="bg-teal-7"  v-if="$slots.header"><slot name="header"></slot></q-toolbar>
        <q-toolbar class="bg-teal-10" v-if="$slots.actions">

          <slot v-if="!responsive||isWindowSize('sm',true)" name="actions"></slot>
          <template v-else>
            <q-space></q-space>
            <q-btn @click="floatMenu=!floatMenu" flat round icon="menu"></q-btn>
          </template>
        </q-toolbar>
      </q-header>
<!--      <q-dialog v-model="floatMenu" side="right" bordered    :width="150"-->
<!--                :breakpoint="500"-->
<!--                behavior="desktop"-->
<!--      >-->
<!--        <q-scroll-area class="fit">-->
<!--          <div class="q-pa-sm">-->
<!--            <slot name="actions"></slot>-->
<!--          </div>-->
<!--        </q-scroll-area>-->
<!--      </q-dialog>-->
      <q-page-container>
        <q-page  v-fill-height="fillHeight">
          <slot></slot>
        </q-page>
      </q-page-container>

    </q-layout>


</template>

<script>
export default {
  name: "SqForm",
  props: {
    responsive: {default: false},
    title: {type: String, default: null},
    shadow: {default: false},
    fillHeight: {type: [Number, Boolean,String], default: 20}
  },
  data() {
    return {

      floatMenu: false
    };
  },
  methods: {}
};
</script>
<style>
.sForm {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
